import React from 'react';

/**
 * Типы вопросов для редактора: название, подсказка «когда использовать» и иконка.
 * Иконки по брендбуку: сетка 24 px, линия 2 px, скруглённые концы, одна деталь — во втором акценте.
 */
export const QUESTION_TYPES = [
    { value: 'single', label: 'Один вариант', hint: 'Выбор одного ответа из списка' },
    { value: 'multiple', label: 'Несколько вариантов', hint: 'Можно отметить несколько ответов' },
    { value: 'rating', label: 'Оценка', hint: '5 или 10 звёзд, NPS' },
    { value: 'wordcloud', label: 'Облако слов', hint: 'Короткий свободный ответ' },
    { value: 'ranking', label: 'Ранжирование', hint: 'Расставить варианты по порядку' },
    { value: 'number', label: 'Число', hint: 'Ответ одним числом' },
    { value: 'grid', label: 'Сетка на картинке', hint: 'Выбрать ячейку изображения' },
    { value: 'heatmap', label: 'Тепловая карта', hint: 'Отметить точки на картинке' },
];

export const typeLabel = (type) => (QUESTION_TYPES.find((t) => t.value === (type || 'single')) || QUESTION_TYPES[0]).label;

// Типы без вариантов ответа
export const NO_OPTION_TYPES = ['grid', 'number', 'rating', 'wordcloud', 'heatmap'];
// Вариант «Другое» — только у выбора
export const OTHER_TYPES = ['single', 'multiple'];
// Тип готового вопроса меняется только внутри этой группы: варианты ответа у них общие
export const SWITCHABLE_TYPES = ['single', 'multiple', 'ranking'];
// Нужна картинка
export const IMAGE_TYPES = ['grid', 'heatmap'];

const PATHS = {
    single: (
        <>
            <circle cx="6" cy="7" r="2.5" />
            <circle cx="6" cy="17" r="2.5" />
            <circle className="qt-accent qt-fill" cx="6" cy="7" r="0.9" />
            <path d="M12 7h8M12 17h8" />
        </>
    ),
    multiple: (
        <>
            <rect x="3.5" y="4.5" width="5" height="5" rx="1.2" />
            <rect x="3.5" y="14.5" width="5" height="5" rx="1.2" />
            <path className="qt-accent" d="M4.8 7l1.2 1.2L8 5.8" />
            <path d="M12 7h8M12 17h8" />
        </>
    ),
    rating: (
        <path className="qt-accent-stroke" d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z" />
    ),
    wordcloud: (
        <>
            <path d="M7 18.5h10a4 4 0 0 0 .6-7.95A5.5 5.5 0 0 0 7.1 9.6 4.5 4.5 0 0 0 7 18.5z" />
            <path className="qt-accent" d="M9.5 14.5h5" />
        </>
    ),
    ranking: (
        <>
            <path d="M4 20V13M12 20V5M20 20v-4" />
            <path className="qt-accent" d="M12 5v15" />
        </>
    ),
    number: (
        <>
            <path d="M9 4l-2 16M17 4l-2 16M4.5 9h15M3.5 15h15" />
            <path className="qt-accent" d="M17 4l-2 16" />
        </>
    ),
    grid: (
        <>
            <rect x="3.5" y="3.5" width="17" height="17" rx="2" />
            <path d="M9.2 3.5v17M14.8 3.5v17M3.5 9.2h17M3.5 14.8h17" />
            <rect className="qt-accent qt-fill" x="9.2" y="9.2" width="5.6" height="5.6" />
        </>
    ),
    heatmap: (
        <>
            <rect x="3.5" y="4.5" width="17" height="15" rx="2" />
            <circle className="qt-accent" cx="13.5" cy="11" r="3.2" />
            <circle className="qt-accent qt-fill" cx="13.5" cy="11" r="0.9" />
            <path d="M3.5 16.5l4.5-4 3 3" />
        </>
    ),
};

export function QuestionTypeIcon({ type, className = '' }) {
    return (
        <svg className={`qt-icon ${className}`.trim()} viewBox="0 0 24 24" fill="none" stroke="currentColor"
             strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden focusable="false">
            {PATHS[type] || PATHS.single}
        </svg>
    );
}
